/**
 * Tooltip copy for the rolling-30d fulfillment-cost KPIs.
 *
 * Single source of truth so the home dashboard and the /fulfillment view
 * always show identical explanations. Update here, both views update.
 */

const COMMON_SOURCE = (
  'Source: ful_order_month, window = last shipment date >= today − 30 days. ' +
  'Sparkline shows monthly totals for the last 6 months (matches the other ' +
  'fulfillment sparklines). Updates as LSM monthly invoices are uploaded; ' +
  'in-month shipments appear after the next invoice lands, so the current ' +
  'month bar grows as invoices arrive.'
);

export const DN_COST_TOOLTIP = (
  'Rolling 30-day cost per LSM-fulfilled DN (Delivery Note). ' +
  'Median = the typical shipment; mean = the bookkeeping average ' +
  '(sensitive to large freight shipments). Max = the single most expensive ' +
  'shipment in the window. ' +
  COMMON_SOURCE
);

export const RT_COST_TOOLTIP = (
  'Rolling 30-day cost per LSM-handled RT (Return). ' +
  'Cost excludes the returns_net flag-bucket (which doubles up on top of ' +
  'physical-work charges) so the number reflects actual handling cost. ' +
  COMMON_SOURCE
);

// Tooltip copy for the surrounding home-dashboard KPIs. Sources noted so a
// future session reading this file knows the SQL anchor.
export const HOME_DASHBOARD_TOOLTIPS = {
  open_purchase_orders:
    'Count of purchase orders not in Draft / Done / Closed / Cancelled. ' +
    'Source: purchase_orders.status (excludes trashed).',
  incoming_inventory_amount:
    'Sum of (shp_stockout_report.incoming_inventory × shp_products.cost_per_item) ' +
    'across active/draft products. Represents EUR value of stock on the way in.',
  current_stock_value:
    'Sum of (shp_stockout_report.inventory_quantity × shp_products.cost_per_item) ' +
    'across active/draft products. Represents EUR value of stock on hand.',
  sales_revenue:
    'Sum of (shp_order_items.quantity × line_item_price) over the last 30 days. ' +
    'Compared against the prior 30 days for the trend %.',
};
